import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';
import { AppBasicsService, ObjectState } from '@meddev/fe-shared';
import { BaseInitAppService } from '@shared/core';
import { AuthAppService, AuthManagerPwaService } from '@shared/data';
import { map, Observable } from 'rxjs';

@Component({
    selector: 'mcl-root',
    imports: [RouterOutlet, CommonModule],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
    private readonly authAppService = inject(AuthAppService);
    private readonly authManager = inject(AuthManagerPwaService);
    private readonly appInitManagerService = inject(BaseInitAppService);
    private readonly appBasicsService = inject(AppBasicsService);
    private readonly appPwaSettings$ = this.appInitManagerService.appPwaSettings$;

    title = $localize`:@@Angular Application title:MCL`;
    isInitializing$ = this.isInitializing();
    userStatus = toSignal(this.authManager.userStatus$);

    ngOnInit(): void {
        this.authAppService.initAfterAppInitializer()?.subscribe();

        this.appPwaSettings$.subscribe(settings => {
            if (settings?.settings?.bsId) {
                this.appBasicsService.setBusinessSubject({
                    id: settings.settings.bsId,
                });
            }
        });

        this.authAppService.getUserInfo().subscribe(userInfo => {
            if (userInfo) {
                this.appBasicsService.setUser({
                    id: userInfo.id,
                    name: userInfo.firstName,
                    surname: userInfo.lastName,
                    email: userInfo.email || '',
                });
            }
        });
    }

    private isInitializing(): Observable<boolean> {
        return this.authAppService.authState$.pipe(
            map(authInfo => {
                const isInitializing = authInfo.state === ObjectState.UNINIT;
                return isInitializing;
            }),
        );
    }
}
